import React from 'react';
import { comum } from "../../../styles/Themes/light";
import { IProposta } from '../../../utility/IProposta';
import {
  Container,
  TitleSection,
  TitleIcon,
  TitleText,
  Label,
  Value,
  Divider
} from './styles';
import { ContentSection, SectionColumn } from '../styles';


interface DadosCorrespondenteCardDemandaProps {
  proposta: IProposta;
  showDivider?: boolean;
}

// Ícone de balança de justiça
const IconScale: React.FC<{ color: string }> = ({ color }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2C13.1 2 14 2.9 14 4C14 5.1 13.1 6 12 6C10.9 6 10 5.1 10 4C10 2.9 10.9 2 12 2ZM21 9V7L15 1H5C3.89 1 3 1.89 3 3V21C3 22.11 3.89 23 5 23H19C20.11 23 21 22.11 21 21V9ZM19 21H5V3H13V9H19V21Z" fill={color}/>
    <path d="M8 12H16V14H8V12ZM8 16H16V18H8V16Z" fill={color}/>
  </svg>
);

export default function DadosCorrespondenteCardDemanda({ proposta, showDivider = false }: DadosCorrespondenteCardDemandaProps) {
  // Só renderiza se houver profissional associado (id_usuario existe e é diferente de 0) - RN15
  if (!proposta.id_usuario || proposta.id_usuario === 0) {
    return null;
  }

  if(proposta.profissional_necessario) {
    proposta.profissional_necessario = proposta.profissional_necessario.replace('_', ' + ')
  }


  return (
    <Container>
      <TitleSection>
        <TitleIcon>
          <IconScale color={comum.colors.interfaceGray300}/>
        </TitleIcon>
        <TitleText>DADOS DO PROFISSIONAL</TitleText>
      </TitleSection>
      
      <ContentSection>
        <SectionColumn>
          <Label>PROFISSIONAL</Label>
          <Value>{proposta.nome_profissional} #{proposta.id_usuario}</Value>
          <Value>{proposta.oab_numero} / {proposta.oab_uf} | {proposta.profissional_necessario}</Value>
        </SectionColumn>
        
        <SectionColumn>
          <Label>CONTATO</Label>
          <Value>{proposta.whatsapp}</Value>
          <Value>{proposta.email}</Value>
        </SectionColumn>
        <SectionColumn></SectionColumn>
      </ContentSection>
      {showDivider && <Divider />}
    </Container>
  );
} 